module.exports = __webpack_public_path__ + "img/wodered.4cf871d6.svg";